// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__-loca-__cd320"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 128
// module chunks = 0